import ElTableColumn from './table-column/index.mjs';
export { default } from './table-column/index.mjs';
//# sourceMappingURL=tableColumn.mjs.map
